import { VINTED_LOCALE_TO_ISO_MAP } from 'constants/language';
export const languageCodeToISO = languageCode => {
  return VINTED_LOCALE_TO_ISO_MAP[languageCode] || 'en';
};